import {apiClient} from "@/services/index";
import {PERP_API_URL} from "@/configs";
import {IPagingParams} from "@/interfaces/api/query";

export const getListProposal = (params: {
  address: string;
  twitter_id: string;
} & IPagingParams): Promise<any[]> => {
  return apiClient.get(`${PERP_API_URL}/api/governor/proposal`, {
    params: {
      network: 'nos',
      ...params,
    },
  });
};

export const getProposalDetail = (id: string, params: {
  address: string;
}): Promise<any> => {
  return apiClient.get(`${PERP_API_URL}/api/governor/proposal/${id}`, {
    params: {
      network: 'nos',
      ...params,
    },
  });
};
